"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SEASON_IDS = void 0;
exports.SEASON_IDS = {
    BUNDESLIGA: {
        SAISON_23_24: '44562567-09d8-4e99-9fad-200e972efba1'
    },
    DFB_POKAL: {
        SAISON_23_24: 'eb6e9e30-eb13-4e6e-bb56-fb1d0cef7333'
    }
};
